import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBanner, ElColumn, ElContent, elGapBanner, ElpoweredImage, ElDetails, ElProgramTitle, ElCircleImg } from "./about-founder.css";
import { Container } from "../../layout";
import { ElHeadLine } from "../head-title";

interface IAboutFounderProps extends HTMLAttributes<HTMLElement> {}

export const AboutFounder: FC<IAboutFounderProps> = ({ children, ...props }) => {
  return (
    <ElBanner {...props}>
      <Container className={elGapBanner}>
        <ElContent>
          <ElHeadLine>About</ElHeadLine>
        </ElContent>
        <ElContent>
          <ElColumn>
            <ElpoweredImage src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/founder.png' />
            <ElCircleImg src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/cicrcle.png' />
          </ElColumn>
          <ElColumn>
            <ElProgramTitle>BEKUP 2025</ElProgramTitle>
            <ElDetails>
              Peningkatan kebutuhan akan talenta di bidang teknologi informasi masih terjadi saat ini. Namun, kesiapan lulusan dalam menghadapi industri digital masih menghadapi{" "}
              <strong>tantangan akibat kesenjangan keterampilan.</strong>
            </ElDetails>
            <ElDetails>
              Untuk menjembatani hal ini, <strong>Deputi Bidang Kreativitas Digital dan Teknologi Kementerian Ekonomi Kreatif/Badan Ekonomi Kreatif</strong> bekerja sama dengan Dicoding dan Kumpul
              menghadirkan Badan Ekraf for Startup (BEKUP) pelatihan intensif yang dirancang untuk memberikan solusi dalam meningkatkan inovasi di industri ekonomi kreatif, membangun ekosistem digital
              yang berkelanjutan serta memberikan kesempatan baru bagi masyarakat.
            </ElDetails>
            <ElDetails>
              BEKUP 2025 dibagi menjadi dua kategori, yakni BEKUP <strong>Accelerate</strong> dan BEKUP <strong>Create.</strong>
            </ElDetails>
          </ElColumn>
        </ElContent>
        {/* <ElBannerContent>
          <ElpoweredImage src={Images.powered} />
        </ElBannerContent> */}
      </Container>
    </ElBanner>
  );
};
